import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const BLOG_POSTS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('BLOG_POSTS');
export const BLOG_POSTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	BLOG_POSTS_CRUD_ACTION_CONSTANTS
);
